export default {

    components: {},

    props: [
        'tableSource'
    ],

    data: () => {
        return {
            tableContents: [],
            fields: [],
        }
    },

    beforeMount() {
        this.tableContents = this.tableSource;

        if(this.tableContents.length === 0) return

        let header = Object.keys(this.tableContents[0]);

        this.fields = header.map((colName) => {
            return {
                key: colName,
                sortable: true,
            }
        })

        return;

        this.fields = [
            {
                key: 'last_name',
                sortable: true
            },
            {
                key: 'first_name',
                sortable: false
            },
            {
                key: 'age',
                label: 'Person age',
                sortable: true,
                // Variant applies to the whole column, including the header and footer
                variant: 'danger'
            }
        ];

    },

    mounted() {

    },
    methods: {}
}
